<template>
    <div class="content-area__content">
        <vue-title :title="$t('identityProvider:changeUsername:title', null, [ $t('shared:fields:username') ])"></vue-title>
        <h1 class="section-title" data-test-element="changeusername-title">{{ $t('identityProvider:changeUsername:title', null, [ $t('shared:fields:username') ]) }}</h1>
        <form ref="form" action="authentication/changeusername" @submit.prevent="validateBeforeSubmit">
            <div class="validation-summary-errors alert alert-danger fade show" role="alert" data-valmsg-summary="true" v-show="model.errorMessage && !errors.any()">
                <i class="material-icons">warning</i>
                <span data-test-element="changeusername-errormessage">{{ model.errorMessage }}</span>
            </div>
            <div class="validation-summary-errors alert alert-danger fade show" role="alert" data-valmsg-summary="true" v-show="errors.any() || hasError">
                <i class="material-icons">warning</i>
                <span v-if="errors.has('.')">{{ errors.first('.') }}</span>
                <span v-else class="alert-message" data-test-element="alert-message">{{ $t('validation:summary') }}</span>
            </div>
            <fieldset class="panel">
                <div class="panel-message" data-test-element="changeusername-instructionmessage">
                    {{ $t('identityProvider:changeUsername:instructions', null, [ $t('shared:fields:username').toLowerCase() ]) }}
                </div>
                <div class="form-group">
                    <label v-on:click.stop>
                        <span class="label" data-test-element="changeusername-label-newusername">{{ $t('identityProvider:changeUsername:newUsername', null, [ $t('shared:fields:username') ]) }}<contextual-help-component :text="model.contextualHelp" data-test-element="changeusername-contextualHelp" tabindex="0"></contextual-help-component></span>
                        <span class="control-with-help-offset">
                            <input name="NewUsername" id="newusername" class="control -with-help" v-model="model.newUsername" v-on:change="onNewUserNameChange" data-test-element="changeusername-newusername" v-validate="'required'" :data-vv-as="$t('identityProvider:changeUsername:newUsername', null, [ $t('shared:fields:username') ])" v-bind:class="{ 'input-validation-error': hasErrorOn('NewUsername') }" autocomplete="off" />
                        </span>
                    </label>
                    <span class="field-validation-error" data-test-element="changeusername-newusername-validationerror" v-show="hasErrorOn('NewUsername')">{{ errors.first('NewUsername') }}</span>
                    <span class="field-validation-error" data-test-element="changeusername-newusername-customvalidationerror" id="newusername-validationerror" style="display:none;"></span>
                </div>
                <div class="form-group">
                    <label>
                        <span class="label" data-test-element="changeusername-label-confirmusername">{{ $t('identityProvider:changeUsername:confirmUsername', null, [ $t('shared:fields:username') ]) }}</span>
                        <span class="control-with-help-offset">
                            <input name="ConfirmUsername" class="control" v-model="model.confirmUsername" data-test-element="changeusername-confirmusername" v-validate="'required|confirmed:NewUsername'" :data-vv-as="$t('identityProvider:changeUsername:confirmUsername', null, [ $t('shared:fields:username') ])" v-bind:class="{ 'input-validation-error': hasErrorOn('ConfirmUsername') }" autocomplete="off" />
                        </span>
                    </label>
                    <span class="field-validation-error" data-test-element="changeusername-confrimusername-validationerror" v-show="hasErrorOn('ConfirmUsername')">{{ errors.first('ConfirmUsername') }}</span>
                </div>
                <div class="form-actions">
                    <button type="submit" name="Action:ChangeUsername" class="button" data-test-element="changeusername-continuebutton" :disabled="disabled">{{ $t('shared:action:continue') }}</button>
                    <a @click.prevent="loginCancel" href="authentication/logincancel" data-test-element="changeusername-cancellink" class="button-secondary link-text-transform">{{ $t('shared:action:cancel') }}</a>
                </div>
            </fieldset>
        </form>
    </div>
</template>

<script>
	import validation from 'utils/validation-mixin';
	import redirectHandler from 'utils/redirect';
	import Vue from 'vue';
  import ContextualHelp from 'components/popper-help';

	Vue.component('contextual-help-component', ContextualHelp);

	export default {
		mixins: [
			validation
		],

		data: () => ({
			model: {
				newUsername: null,
				confirmUsername: null,
				contextualHelp: null
			},
			hasError: false,
			disabled: false
		}),

		methods: {

			onNewUserNameChange() {
				$('#newusername-validationerror').text('').css('display', 'none');
				$('#newusername').removeClass('input-validation-error');
			},

			displayErrorMessage(errorMesage) {
				$('#newusername-validationerror').text(errorMesage).css('display', 'block');
				$('#newusername').addClass('input-validation-error');
				this.hasError = true;
			},

			validateUsername() {
				var emailExpression = new RegExp(this.model.emailRegex);
				var invalidUsername = new RegExp(this.model.usernamePattern);
				alert
				if (this.model.enabledUserNameEmailValidation && emailExpression.test(this.model.newUsername)) {
					this.displayErrorMessage(this.model.emailValidationMessage);
					return true;
				}
				else if (!invalidUsername.test(this.model.newUsername)) {
					this.displayErrorMessage(this.model.usernamePatternMessage);
					return true;
				}

				return false;
			},

			validateBeforeSubmit() {
				// Disabling the custom error message div on submit request.
				this.model.errorMessage = null;
				this.$validator.reset()
					.then(_ => {
						this.$validator.validateAll().then(result => {
							if (result) {
								if (!this.validateUsername()) {
									this.post();
								}
							}
						});
					});
			},

			async post() {
				let form = this.$refs.form;
				this.disabled = true;
				try {
					let response = await this.$http.post(form.action, this.model);
					this.model = response.data;
					redirectHandler.checkAndRedirect(response, this.$router);
				} catch (error) {
					if (this.validateResponse(form, error.response)) {
						return;
					}
					throw error;
				} finally {
					this.disabled = false;
					this.hasError = false;
				}
			},

			async loginCancel(event) {
				let response = await this.$http.post(event.target.href);
				redirectHandler.checkAndRedirect(response, this.$router);
			}
		},

		async mounted() {
			let form = this.$refs.form;
			let response = await this.$http.get(form.action);
			this.model = response.data;
		}
	};
</script>